export default ({ COLORS }) => ({
  noChildren: {
    margin: '20px 0 0',
    color: COLORS.TEXT.LIGHT_GREY.NORMAL
  }
})
